import React from 'react';

type IProps = {}
const PlansTable: React.FC<IProps> = (props) => {
  return (
    <>
      <table
        className="plan-table"
        style={{
          width: '100%',
          maxWidth: '1024px',
          marginBottom: '10px'
        }}
      >
        <tr className="element__table-grid">
          <th rowSpan={2}>保險項目</th>
          <th rowSpan={2} colSpan={2}>承保範圍</th>
          <th colSpan={3}>保險金額（NT$）</th>
        </tr>
        <tr>
          <th>基本呵護3.0</th>
          <th>完整保護3.0</th>
          <th>全面守護3.0</th>
        </tr>
        <tr className="element__table-grid">
          <td rowSpan={9} className="element__table-grid-y-title-pet">寵物醫療費用</td>
          <td rowSpan={3} className="element__table-grid-y-title-pet">門診費用</td>
          <td className="element__table-grid-y-title-pet">每一保險事故保險金額</td>
          <td>1,800</td>
          <td>2,300</td>
          <td>2,700</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">保險期間內累積最高賠償限額</td>
          <td>4,500</td>
          <td>5,750</td>
          <td>6,750</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">自負額</td>
          <td>損失之20%</td>
          <td>損失之20%</td>
          <td>損失之20%</td>
        </tr>
        <tr className="element__table-grid">
          <td rowSpan={3} className="element__table-grid-y-title-pet">住院費用</td>
          <td className="element__table-grid-y-title-pet">每一保險事故保險金額</td>
          <td>9,000</td>
          <td>11,500</td>
          <td>13,500</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">保險期間內累積最高賠償限額</td>
          <td>18,000</td>
          <td>23,000</td>
          <td>27,000</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">自負額</td>
          <td>損失之20%</td>
          <td>損失之20%</td>
          <td>損失之20%</td>
        </tr>
        <tr className="element__table-grid">
          <td rowSpan={3} className="element__table-grid-y-title-pet">手術費用</td>
          <td className="element__table-grid-y-title-pet">每一保險事故保險金額</td>
          <td>22,500</td>
          <td>28,750</td>
          <td>33,750</td>
        </tr>
        <tr className="element__table-grid">
          <td className="element__table-grid-y-title-pet">保險期間內累積最高賠償限額</td>
          <td>45,000</td>
          <td>57,500</td>
          <td>67,500</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">自負額</td>
          <td>損失之20%</td>
          <td>損失之20%</td>
          <td>損失之20%</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物侵權責任</td>
          <td>100萬</td>
          <td>100萬</td>
          <td>100萬</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物協尋廣告費用</td>
          <td>2,000</td>
          <td>2,000</td>
          <td>2,000</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">被保險人住院期間寄宿日額費用(每日)</td>
          <td>-</td>
          <td>1,000</td>
          <td>1,000</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物喪葬費用</td>
          <td>-</td>
          <td>5,000</td>
          <td>5,000</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物重新取得費用</td>
          <td>-</td>
          <td>5,000</td>
          <td>5,000</td>
        </tr>
        <tr className="element__table-grid">
          <td rowSpan={2} className="element__table-grid-y-title-pet">預估保險費</td>
          <td colSpan={2} className="element__table-grid-y-title-pet">狗</td>
          <td>3,338</td>
          <td>4,761</td>
          <td>5,326</td>
        </tr>
        <tr>
          <td colSpan={2} className="element__table-grid-y-title-pet">貓</td>
          <td>2,687</td>
          <td>3,937</td>
          <td>4,390</td>
        </tr>
      </table>
      <div style={{ color: 'red', textAlign: 'left' }}>
        <span style={{ display: 'block' }}>1.單位：新台幣元(NT$)</span>
        <span style={{ display: 'block' }}>2.上述保費以混種、年齡2個月以上至8歲6個月內、已絕育、試算:實際保費依要被保寵物「品種」、「年齡」、「絕育情形」等條件重新計算。(詳見常見QA)</span>
        <span style={{ display: 'block' }}>3.本商品並非保證續保，隔年度將依據實際理賠狀況決定是否得以續保。</span>
        <span style={{ display: 'block' }}>4.針對同一疾病或傷害，或因此引起之併發症，14日內於任何獸醫院再次診療時，保險公司對各項保險金給付合計額，視為同一保險事故。</span>
      </div>
    </>
  );
};

export default PlansTable;
